/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-12-03 15:35:19
 * @modify date 2021-12-03 15:35:19
 * @desc API 格式 https://{domain}/api/{app-name}/{service-name}/{service-uri}
 */
import { Utils } from '../libraries';
import { EnumApiAccountsvr } from './accountsvr';
import { EnumApiBffsvr } from './bffsvr';
import { EnumApiComsvr } from './comsvr';
import { EnumApiContent } from './content';
import { EnumApiCultivate } from './cultivate';
import { EnumApiLegal } from './legal';
import { EnumApiLexiang } from './lexiang';
import { EnumApiLiveMudusvr } from './livemudu';
import { EnumApiOrgidasssvr } from './orgidasssvr';
import { EnumApiPartnersvr } from './partnersvr';
import { EnumApiProtect } from './protect';
import { EnumApiRegionorgsvr } from './regionorgsvr';
import { EnumApiUsersvr } from './usersvr';
import { EnumApiWechat } from './wechat';
import { EnumApiXiaozhi } from './xiaozhi';
export const EnumAPI = {
  ...new EnumApiBffsvr(),
  ...new EnumApiComsvr(),
  ...new EnumApiAccountsvr(),
  ...new EnumApiWechat(),
  ...new EnumApiUsersvr(),
  ...new EnumApiContent(),
  ...new EnumApiOrgidasssvr(),
  ...new EnumApiRegionorgsvr(),
  ...new EnumApiPartnersvr(),
  ...new EnumApiProtect(),
  ...new EnumApiXiaozhi(),
  ...new EnumApiCultivate(),
  ...new EnumApiLegal(),
  ...new EnumApiLiveMudusvr(),
  ...new EnumApiLexiang(),
};
Utils.toReadonly(EnumAPI);
